import { render, staticRenderFns } from "./ParticipantListItem.vue?vue&type=template&id=25b5d8b9&scoped=true&"
import script from "./ParticipantListItem.vue?vue&type=script&lang=js&"
export * from "./ParticipantListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5d8b9",
  null
  
)

export default component.exports